export var RadioCssClass;
(function (RadioCssClass) {
    RadioCssClass["Base"] = "iress-radio";
    RadioCssClass["Label"] = "iress-radio__label";
    RadioCssClass["Input"] = "iress-radio__input";
    RadioCssClass["Focus"] = "iress-radio--focus";
    RadioCssClass["Hover"] = "iress-radio--hover";
    RadioCssClass["Mark"] = "iress-radio__mark";
    RadioCssClass["Checked"] = "iress-radio--checked";
    RadioCssClass["Border"] = "iress-radio--border";
})(RadioCssClass || (RadioCssClass = {}));
//# sourceMappingURL=radio.types.js.map